<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "CommonSettingLayout"
}
</script>

<style scoped>

</style>